import React from 'react';
import { useParams } from 'react-router-dom';

// 예약된 슬러그 목록
const RESERVED_SLUGS = [
  'qr', 'privacy-policy', 'terms', 'delete-account', 'assets', 'api',
  'login', 'register', 'dashboard', 'home', 'admin', 'system', 'app',
  'www', 'mail', 'ftp', 'smtp', 'pop', 'imap', 'webmail', 'cpanel',
  'phpmyadmin', 'wp-admin', 'wp-content', 'wp-includes', 'wordpress',
  'blog', 'forum', 'shop', 'store', 'cart', 'checkout', 'payment',
  'support', 'help', 'faq', 'contact', 'about', 'team', 'careers',
  'privacy', 'terms-of-service', 'legal', 'sitemap', 'robots',
  'favicon', 'manifest', 'service-worker', 'sw', 'pwa'
];

const UserProfilePage: React.FC = () => {
  const { username } = useParams<{ username: string }>();

  // 예약된 슬러그인지 확인
  const isReservedSlug = username && RESERVED_SLUGS.includes(username.toLowerCase());

  if (isReservedSlug) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6 text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">예약된 슬러그</h1>
          <p className="text-gray-600 mb-4">
            <strong>{username}</strong>은(는) 예약된 슬러그입니다.
          </p>
          <p className="text-sm text-gray-500">
            다른 사용자명을 사용해주세요.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Profile Loading</h1>
        <p className="text-gray-600 mb-4">
          Loading profile for: <strong>{username}</strong>
        </p>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        <p className="text-sm text-gray-500 mt-4">
          If this page doesn't redirect automatically, please refresh the page.
        </p>
      </div>
    </div>
  );
};

export default UserProfilePage;

